import { axiosInstance, type CustomResponseFormat } from "api/instance";

export const COMMITMENT_DOMAIN = "commitment";
export const COMMITMENT_SUBMIT_ENDPOINT = "submit";
export const COMMITMENT_DETAIL_ENDPOINT = "detail";

export interface CommitmentSignatureType {
  signature: string;
}

export interface CommitmentDetailType {
  signature?: string;
  committedAt?: string;
}

export const commitmentApi = {
  submit: (body: CommitmentSignatureType) =>
    axiosInstance.post<CustomResponseFormat>(
      `${COMMITMENT_DOMAIN}/${COMMITMENT_SUBMIT_ENDPOINT}`,
      body
    ),
  getDetail: () =>
    axiosInstance.get<
      CustomResponseFormat<CommitmentDetailType | undefined | null>
    >(`${COMMITMENT_DOMAIN}/${COMMITMENT_DETAIL_ENDPOINT}`),
};
